import { useContext } from 'react';
import { tableMultiBodyContext } from './context';
export var useTableMultiBody = function () {
    var wrapping = useContext(tableMultiBodyContext);
    return wrapping;
};
